module.exports = "<a href=\"javascript:;\" class=\"history-item-link\" data-type=\"search\">\r\n    <i aria-hidden=\"true\" class=\"fa fa-search\"></i>\r\n    {{Model.Value.Query}}\r\n</a>\r\n<div class=\"timestamp\" title=\"{{Model.Timestamp}}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/user-history/views/user-history-item-search.html
// module id = 452
// module chunks = 1